
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15981","data-name":"Rectangle 15981","width":"12","height":"14","fill":"none","stroke":"#fff","stroke-width":"1"}})])]),_c('g',{attrs:{"id":"Group_49138","data-name":"Group 49138","transform":"translate(-1385 -775)"}},[_c('rect',{attrs:{"id":"Rectangle_16712","data-name":"Rectangle 16712","width":"32","height":"32","rx":"8","transform":"translate(1385 775)","fill":"#aaaaf4"}}),_c('g',{attrs:{"id":"Group_49137","data-name":"Group 49137","transform":"translate(1395.5 784)"}},[_c('g',{attrs:{"id":"Group_47852","data-name":"Group 47852","clip-path":"url(#clip-path)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"id":"Path_37642","data-name":"Path 37642","d":"M1 6l5-5 5 5m-5 7V1"}}),_c('path',{attrs:{"id":"Path_37643","data-name":"Path 37643","d":"M1 6l5-5 5 5m-5 7V1"}})])])])])
          )
        }
      }
    